<div class="d-flex jc-between p-y-10">
  <p class="text-20 f-w-400">
    Observação da {{ orderCheck.IsGroupCheck ? "mesa" : "comanda" }}
  </p>
  <i-tabler name="x" class="icon-20 stroke-1 text-danger" (click)="close()"></i-tabler>
</div>
<div class="p-20">
  <form class="w-100 m-t-10" [formGroup]="form" (ngSubmit)="handleAddObservation()">
    <div class="row">
      <div class="col-12 p-0 m-0">
        <app-textarea nameControl="Observation" textLabel="Observação" rows="4" />
      </div>
    </div>
    <button class="btn w-100 flat-button m-t-20" [disabled]="form.invalid">
      Ok
    </button>
  </form>
</div>